<template>
  <div class="im-store" style="-webkit-app-region: drag">
    <div style="height: 44px; background: #eee;padding: 10px;border-right: 1px solid #dcdee2;">
      我的店铺
    </div>
    <div class="shopee-store-wrap" ref="personWrap">
      <Scroll :height="scrollHeight">
      <List :split="false" class="store-list">
          <ListItem @click.native="setCurrentStore(store)" v-for="(store, index) in storeList" :key="index" :class="{active: activeStore == store.shop_id, 'expire-store': store.im_expiresin_text == '已过期'}" class="store-item">
            <div style="padding: 0px 10px;position: relative;">
              
              <Badge :count="unread_count(store.shop_id)">
                  <Avatar :src="(store.im_expiresin_text != '已过期' ? store.logo_url : logo_url_grey)" shape="square" icon="ios-person" />
                  <div v-show="store.hang == 1" @click="nohang(store)" style="position: absolute;top: 16px;right: 0px;">
                    <Icon color="#ff0000" type="ios-pause" />
                  </div>
              </Badge>
              <Badge v-if="transfer_count(store.shop_id)" text="转" type="primary">
                  <a href="#" class="demo-badge"></a>
              </Badge>
              <span class="store-name">{{store.name}}</span>
              
            </div>
            
            <div style="margin-left: 20px;position: absolute;right: 0px;padding: 5px;">
              <Dropdown trigger="click" style="padding: 10px;">
                  <a href="javascript:void(0)">
                      <Icon type="ios-arrow-down"></Icon>
                  </a>
                  <DropdownMenu slot="list">
                      <DropdownItem @click.native="hang(store)">挂起</DropdownItem>
                  </DropdownMenu>
              </Dropdown>
            </div>
          </ListItem>
      </List>
      </Scroll>
    </div>

  </div>
</template>
<script>
import RequestUtils from "../../../../utils/RequestUtils";
import conf from "../../conf";

export default {
  data() {
    return {
      // 默认选中的值
      icon: "ios-square-outline",
      isStoreDown: false,
      scrollHeight: 500,
      logo_url_grey: require('@/static/img/logo_url_grey.png')
    };
  },
  computed: {
    storeList: {
      get: function() {
        return this.$store.state.shopee.storeList;
      }
    },
    sessionData: {
      get: function() {
        let shop_id = this.$store.state.shopee.currentStore.shop_id;
        if (this.$store.state.shopee.sessionData[shop_id]) {        
          return this.$store.state.shopee.sessionData[shop_id];
        }
        return [];
      },
    },
    activeStore: {
      get: function () {
        return this.$store.state.shopee.currentStore.shop_id;
      }
    },
    unread_count() {
      return function (shop_id) {
        return this.$store.state.shopee.storeData[shop_id].unread_count; 
      }
    },
    transfer_count() {
      return function (seller_id) {
        return this.$store.state.shopee.storeData[seller_id].transfer_count; 
      }
    }
  },
  methods: {
    storeDown() {
      this.isStoreDown = !this.isStoreDown;
    },
    setCurrentStore(store) {
      let self = this;
      self.$store.commit("shopee/setCurrentStore", store);
      self.$emit('updatesession');
    },
    selectstore(store, callback) {
      let self = this;
      let param = new FormData();
      param.set("store_id", store.id);
      param.set("direction", 'older');
      param.set("type", 'all');

      RequestUtils.request(conf.getSessionList(), param)
      .then(data => {
        data.store_id = store.id;
        data.shop_id = store.shop_id;
        console.log(data.conversations);
        self.$store.commit("shopee/setSessionData", data);
        callback && callback();
      })
      .then(() => {
        self.moreSession(2, store.shop_id);
      })
    },
    moreSession(next, shop_id) {
      if (!next) return false;
      let self = this;
      let sessionData = this.$store.state.shopee.sessionData[shop_id];
      if (!sessionData.page_result.more) return false;
      let param = new FormData();
      param.set("store_id", sessionData.store_id);
      param.set("direction", 'older');
      param.set("type", 'all');
      param.set("next_timestamp_nano", sessionData.page_result.next_cursor.next_message_time_nano);

      RequestUtils.request(conf.getSessionList(), param)
      .then(data => {
        data.shop_id = sessionData.shop_id;
        data.conversations = data.conversations.map(function (elem) {
          elem.last_message_timestamp = (elem.last_message_timestamp+"").substr(0, 10)*1;
          return elem;
        });
        self.$store.commit("shopee/pushSessionList", data);
        next--;
        self.moreSession(next, shop_id);
      })
    },
    // 挂起店铺
    hang (store) {
      let param = new FormData();
      param.set("store_id", store.id );
      param.set("platform", 'shopee' );

      RequestUtils.request(conf.hangStore(), param)
      .then(() => {                  
        this.$store.commit("shopee/setStoreAttr", {
          'id': store.id,
          'attr': 'hang',
          'value': 1
        });
        this.$Message.success('店铺已被挂起');
      })
    },
    // 取消挂起
    nohang (store) {
      let param = new FormData();
      param.set("store_id", store.id );
      param.set("platform", 'shopee' );
      param.set("operate", 'nohang' );

      RequestUtils.request(conf.hangStore(), param)
      .then(() => {                  
        this.$store.commit("shopee/setStoreAttr", {
          'id': store.id,
          'attr': 'hang',
          'value': 0
        });
      })
    },
  },
  mounted: function() {
    this.scrollHeight = document.querySelector('body').offsetHeight - 64 - 36 - 46 - 44;
  }
};
</script>
<style lang="scss">
@import "@/static/styles/theme";

$top-height: 4rem;
$color-online: #d1ffe9;

.shopee-store-wrap {
  position: relative;

  .store-list {
    
    .store-name {
      padding: 0px 1rem;

    }
    .store-item{
      cursor: pointer;
    }
    .store-item.active {
      background-color: rgba(0,29,233,.06);
      color: #07f;
    }
    .store-item.expire-store {
      opacity: .5
    }
    .expire-store .ivu-badge-count {
      background: #999;
    }

    .store-down {
      width: 50px;
      height: 52px;
      cursor: pointer;
      display: flex;
      justify-content: center;
      align-items: center;
      position: absolute;
      top: 0px;
      right: 50px;
    }
  }
  .store-list.down {
    height: auto;
    z-index: 999;
    box-shadow: 1px 8px 18px rgba(0, 0, 0, 0.1);
  }
}
.store {
  height: 5.2rem;
  position: relative;

  a {
    display: block;
    width: 100%;
    height: 100%;
    color: $color-default;
    position: relative;

    i {
      display: inline-block;
      width: 1.8rem;
      height: 1.6rem;
      background-color: #ff0000;
      border-radius: 50%;
      color: $color-write;
      text-align: center;
      font-style: normal;
      position: absolute;
      left: 1rem;
      top: 0;
      z-index: 99999999999;
    }

    p {
      width: 12rem;
    }
  }


}
</style>
